// src/auth/authConfig.js
const isProduction = process.env.NODE_ENV === 'production';

// Get the API scope from environment variables
const apiScope = process.env.REACT_APP_API_SCOPE;

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        allowRedirectInIframe: true, // Enable redirects in iframes for better popup handling
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 0:
                        console.error(message);
                        return;
                    case 1:
                        console.warn(message);
                        return;
                    case 2:
                        console.info(message);
                        return;
                    case 3:
                        console.debug(message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: isProduction ? 0 : 3 // Only show errors in production
        }
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read", apiScope].filter(Boolean) // Filter out undefined scopes
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// Helper function to validate environment variables
export const validateAuthConfig = () => {
    const requiredVars = [
        'REACT_APP_AZURE_CLIENT_ID',
        'REACT_APP_AZURE_TENANT_ID'
    ];

    const missingVars = requiredVars.filter(varName => !process.env[varName]);

    if (missingVars.length > 0) {
        console.error('Missing required environment variables:', missingVars.join(', '));
        return false;
    }

    return true;
}; 